import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { apiBaseUrl } from "@/api/service";
import util from "@/libs/util.js";
import CompanyInfoDialog from "./components/CompanyInfoDialog.vue";
import AuthDetailDialog from "./components/AuthDetailDialog.vue";
import DepositOperationDialog from "./components/DepositOperationDialog.vue";
export default {
  name: "brand-company",
  components: {
    CompanyInfoDialog: CompanyInfoDialog,
    AuthDetailDialog: AuthDetailDialog,
    DepositOperationDialog: DepositOperationDialog
  },
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        id: this.$route.query.id || "",
        companyName: this.$route.query.company || ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数
      addVisible: this.$route.query.type == "add" ? true : false,
      addForm: {},
      addRules: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        personCharge: [{
          required: true,
          message: "请选择负责人",
          trigger: "blur"
        }],
        certificationType: [{
          required: true,
          message: "请选择认证类型",
          trigger: "blur"
        }]
      }, "certificationType", [{
        required: true,
        message: "请选择认证类型",
        trigger: "blur"
      }]), "certificationName", [{
        required: true,
        message: "请输入认证名称",
        trigger: "blur"
      }]), "authNo", [{
        required: true,
        message: "请输入认证唯一编码",
        trigger: "blur"
      }]), "companyName", [{
        required: true,
        message: "请输入公司名",
        trigger: "blur"
      }]), "city", [{
        required: true,
        message: "请输入城市",
        trigger: "blur"
      }]), "counterpart", [{
        required: true,
        message: "请输入对接人",
        trigger: "blur"
      }]), "counterpartPhone", [{
        required: true,
        message: "请输入对接人手机号",
        trigger: "blur"
      }]),
      previewVisible: false,
      previewImageUrl: "",
      disSubmit: false,
      fileList: [],
      typeTags: [],
      typeTagsVal: [],
      cityList: [],
      adminList: [],
      depositTotal: 0,
      authDetailDialogVisible: false,
      authDetail: {},
      depositDialogVisible: false,
      depositForm: {},
      saveCompanyDepositOrderLoading: false,
      depositStatusMap: {
        "newly": "10",
        "deduct": "20",
        "refund": "30",
        "audit_refund": "31"
      },
      depositTypeMap: {
        "newly": "新增",
        "deduct": "扣除",
        "refund": "退还",
        "revocation": "退还"
      },
      companyDepositList: [],
      isHasPaymentType: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.$route.query.companyName && (_this.searchForm.companyName = _this.$route.query.companyName);
            _this.getData();
            _this.getTypeTagList();
            _this.getAdminList();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    selectDepositOrder: function selectDepositOrder(row) {
      var _this2 = this;
      this.companyDepositList.forEach(function (item) {
        if (item.id == row.id) {
          item.isSelected = 1;
          _this2.depositForm.certificateUrl = item.certificateUrl;
          _this2.depositForm.depositId = item.id;
          _this2.depositForm.residue = item.residue;
          if (item.paymentType) {
            _this2.depositForm.paymentType = item.paymentType;
          }
          _this2.isHasPaymentType = item.paymentType ? true : false;
        } else {
          item.isSelected = 0;
        }
      });
    },
    getCompanyDepositListByCompanyId: function getCompanyDepositListByCompanyId() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this3.$api.getCompanyDepositListByCompanyId({
                companyId: _this3.depositForm.id
              });
            case 1:
              res = _context2.v;
              res.data.forEach(function (item) {
                item.isSelected = 0;
                item.residue = item.amount;
                // item.paymentType = 'beijing';
                item.companyDepositOrderVos.forEach(function (order) {
                  if (order.operationType !== "revocation") {
                    item.residue += order.amount;
                  }
                });
                item.residue = item.residue < 0 ? 0 : item.residue;
              });
              console.log(res.data);
              _this3.companyDepositList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    depositDialog: function depositDialog(row) {
      var form = {
        id: row.id,
        companyName: row.companyName,
        certificationType: row.certificationType,
        certificationName: row.certificationName,
        authNo: row.authNo,
        deposit: row.deposit,
        operationType: "",
        operationDesc: "",
        certificateUrl: "",
        paymentType: ""
      };
      this.$refs.depositDialog.open(form);
    },
    saveCompanyDepositOrder: function saveCompanyDepositOrder() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, code;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              console.log(_this4.saveCompanyDepositOrderLoading);
              if (!_this4.saveCompanyDepositOrderLoading) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!(_this4.depositForm.operationType == "")) {
                _context3.n = 2;
                break;
              }
              _this4.$message.error("请选择操作类型");
              return _context3.a(2);
            case 2:
              if (_this4.depositForm.amount) {
                _context3.n = 3;
                break;
              }
              _this4.$message.error("请输入金额");
              return _context3.a(2);
            case 3:
              if (!(_this4.depositForm.operationType == "refund" || _this4.depositForm.operationType == "newly")) {
                _context3.n = 4;
                break;
              }
              if (_this4.depositForm.paymentType) {
                _context3.n = 4;
                break;
              }
              _this4.$message.error("请选择支付平台");
              return _context3.a(2);
            case 4:
              if (!(_this4.depositForm.operationType == "newly")) {
                _context3.n = 5;
                break;
              }
              if (!(_this4.depositForm.certificateUrl == "")) {
                _context3.n = 5;
                break;
              }
              _this4.$message.error("请上传押金支付凭证");
              return _context3.a(2);
            case 5:
              if (!(_this4.depositForm.operationType == "refund" || _this4.depositForm.operationType == "deduct")) {
                _context3.n = 7;
                break;
              }
              if (_this4.depositForm.depositId) {
                _context3.n = 6;
                break;
              }
              _this4.$message.error("请选择押金记录");
              return _context3.a(2);
            case 6:
              if (!(_this4.depositForm.amount > _this4.depositForm.residue)) {
                _context3.n = 7;
                break;
              }
              _this4.$message.error("金额不能大于剩余金额");
              return _context3.a(2);
            case 7:
              _this4.saveCompanyDepositOrderLoading = true;
              _context3.n = 8;
              return _this4.$api.saveCompanyDepositOrder({
                id: _this4.depositForm.depositId,
                companyId: _this4.depositForm.id,
                operationType: _this4.depositForm.operationType,
                certificateUrl: _this4.depositForm.certificateUrl,
                operationDesc: _this4.depositForm.operationDesc,
                adminId: util.cookies.get("uuid"),
                amount: _this4.depositForm.operationType == "newly" ? _this4.depositForm.amount : _this4.depositForm.amount * -1,
                status: _this4.depositStatusMap[_this4.depositForm.operationType],
                paymentType: _this4.depositForm.paymentType
              });
            case 8:
              res = _context3.v;
              if (res.code == 200) {
                code = '';
                if (_this4.depositForm.operationType == 'newly') {
                  code = 'depositoperation_add';
                } else if (_this4.depositForm.operationType == 'refund') {
                  code = 'depositoperation_refund';
                } else if (_this4.depositForm.operationType == 'deduct') {
                  code = 'depositoperation_deduct';
                }
                // 操作上报
                _this4.$operationLog.push({
                  operationType: 'order',
                  operationOrderType: 'quarter_deposit',
                  code: code,
                  detailBatchNo: res.data
                });
                _this4.$message.success("操作成功");
                _this4.depositDialogVisible = false;
                _this4.getData();
              } else {
                _this4.$message.error(res.msg);
              }
            case 9:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getCityList: function getCityList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this5.$api.getCityListByPy();
            case 1:
              res = _context4.v;
              _this5.cityList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this6.$api.getAdminUser({
                type: "operate"
              });
            case 1:
              res = _context5.v;
              _this6.adminList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getTypeTagList: function getTypeTagList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this7.typeTagsVal = [];
              _context6.n = 1;
              return _this7.$api.getHouseTypeTagList({
                type: "all"
              });
            case 1:
              res = _context6.v;
              _this7.typeTags = res.data;
              // this.typeTags.forEach((item) => {
              //     if (this.houseForm.typeTags.indexOf(item.ch) > -1) {
              //         this.typeTagsVal.push(item.id);
              //     }
              // });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    deleteItem: function deleteItem(row) {
      var _this8 = this;
      this.$confirm("删除该公司信息， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var form;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              form = new FormData();
              form.set("id", row.id);
              _context7.n = 1;
              return _this8.$api.deleteBqCompanyinfo(form);
            case 1:
              // 操作上报
              _this8.$operationLog.push({
                operationType: 'text',
                code: "delete",
                detailBatchNo: row.companyName
              });
              _this8.$message.success("操作成功");
              _this8.getData();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var price, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (type === "search") {
                _this9.searchForm.pageNum = 1;
              }
              if (_this9.searchForm.priceId && _this9.searchForm.priceId.length > 0) {
                price = _this9.searchForm.priceId.split(",");
                _this9.searchForm.minPrice = price[0];
                _this9.searchForm.maxPrice = price[1];
              }
              _this9.tableLoading = true;
              _context8.n = 1;
              return _this9.$api.findAllBqCompanyinfo(_this9.searchForm);
            case 1:
              res = _context8.v;
              res.data.content.forEach(function (item) {
                item.tagIds = [];
                item.tagNames = [];
                if (item.tags.length > 0) {
                  item.tags.forEach(function (tag) {
                    item.tagIds.push(tag.tagId);
                    item.tagNames.push(tag.tagName);
                  });
                }
              });
              if (res.data.content.length > 0) {
                _this9.depositTotal = res.data.content[0].depositTotal;
              }
              _this9.tableData = res.data.content;
              _this9.total = res.data.totalCount;
              _this9.tableLoading = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    beforeClose: function beforeClose(done) {
      this.fileList = [];
      done && done();
    },
    onCompanySaved: function onCompanySaved() {
      this.getData();
    },
    handleRemove: function handleRemove(file, fileList) {
      var _this0 = this;
      if (fileList) {
        fileList.forEach(function (item, index) {
          if (file.uid == item.uid) {
            fileList.splice(index, 1);
          }
        });
      } else {
        this.fileList.forEach(function (item, index) {
          if (file.uid == item.uid) {
            _this0.fileList.splice(index, 1);
          }
        });
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.$hevueImgPreview(file.url);
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.fileList = fileList;
      } else {
        fileList.forEach(function (item, index) {
          if (file.uid == item.uid) {
            fileList.splice(index, 1);
          }
        });
        this.$message.error(res.msg);
      }
    },
    uploadChange: function uploadChange(file, fileList) {
      if (file.response && file.response.code == 200) {
        file.loading = false;
      } else {
        file.loading = true;
      }
    },
    addItem: function addItem() {
      this.addForm = {};
      this.$refs.companyInfoDialog.open();
    },
    updateItem: function updateItem(row) {
      this.$refs.companyInfoDialog.open(row);
    },
    submit: function submit() {
      var _this1 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this1.saveOrUpdateBqCompanyinfo();
        } else {
          return false;
        }
      });
    },
    saveOrUpdateBqCompanyinfo: function saveOrUpdateBqCompanyinfo() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this10.disSubmit = true;
              _this10.addForm.tags = [];
              if (_this10.typeTagsVal.length > 0) {
                _this10.typeTags.forEach(function (item) {
                  if (_this10.typeTagsVal.indexOf(item.id) > -1) {
                    _this10.addForm.tags.push({
                      tagId: item.id,
                      tagName: item.ch
                    });
                  }
                });
              }
              console.log(_this10.fileList);
              _this10.addForm.businessLicense = _this10.fileList.map(function (i) {
                return i.response ? i.response.data : i.url;
              }).toString();
              _context9.n = 1;
              return _this10.$api.saveOrUpdateBqCompanyinfo(_this10.addForm);
            case 1:
              res = _context9.v;
              _this10.beforeClose();
              // 操作上报
              _this10.$operationLog.push({
                operationType: 'quarter_company',
                code: _this10.addForm.id ? "edit" : "add",
                detailBatchNo: res.data
              });
              _this10.$message.success("操作成功");
              _this10.disSubmit = false;
              _this10.addVisible = false;
              _this10.getData();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    businessLicenseDetail: function businessLicenseDetail(row) {
      row.urls = row.businessLicense.split(",");
      this.authDetail = row;
      this.$refs.authDialog.open(row);
    }
  }
};